// eslint-disable-next-line import/prefer-default-export
export const IS_INITIAL_DATA_SET = 'Is Initial data set to store';
